import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

const ANAG = [["nome", "Nome"], ["cognome", "Cognome"], ["telefono", "Telefono"]];
const COMPANY = [["ragione_sociale", "Ragione sociale"], ["piva", "P. IVA"], ["codice_fiscale", "Codice fiscale"], ["iban", "IBAN"], ["sede", "Sede legale"]];
const REGIMI = ["Ordinario", "Semplificato", "Forfettario", "Agricoltura", "Altro"];
const blank = { email: "", anagrafica: { nome: "", cognome: "", email: "", telefono: "" }, company: { ...Object.fromEntries(COMPANY.map(([k]) => [k, ""])), regime_fiscale: "Ordinario" }, send_invite: true };

const Grid = ({ defs, value, onChange, prefix }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
    {defs.map(([k, l]) => (
      <div key={k}><Label className="text-xs">{l}</Label><Input value={value[k] || ""} onChange={(e) => onChange({ ...value, [k]: e.target.value })} data-testid={`${prefix}-${k}`} /></div>
    ))}
  </div>
);

export const ResellerDialog = ({ open, onOpenChange, reseller, onSave, saving }) => {
  const isEdit = !!reseller;
  const [f, setF] = useState(blank);
  useEffect(() => {
    if (open) {
      setF(reseller ? { email: reseller.email || "", anagrafica: { ...blank.anagrafica, ...reseller.anagrafica }, company: { ...blank.company, ...reseller.company }, send_invite: false } : blank);
    }
  }, [open, reseller]);
  const emailLocked = isEdit && reseller.has_login;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="reseller-dialog">
        <DialogHeader><DialogTitle>{isEdit ? "Modifica rivenditore" : "Nuovo rivenditore"}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div>
            <Label className="text-xs">Email di accesso</Label>
            <Input type="email" value={f.email} disabled={emailLocked} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="rd-email" />
            <p className="text-xs text-slate-500 mt-1">{emailLocked ? "Il rivenditore ha già un accesso: l'email non si può cambiare." : "Il rivenditore dovrà registrarsi con questa email per trovare la scheda già compilata."}</p>
          </div>
          <div><div className="text-xs font-semibold mb-2">Referente</div><Grid defs={ANAG} value={f.anagrafica} onChange={(v) => setF({ ...f, anagrafica: v })} prefix="rd-anag" /></div>
          <div><div className="text-xs font-semibold mb-2">Azienda</div><Grid defs={COMPANY} value={f.company} onChange={(v) => setF({ ...f, company: v })} prefix="rd-company" />
            <div className="mt-3"><Label className="text-xs">Regime fiscale</Label>
              <select value={f.company.regime_fiscale || "Ordinario"} onChange={(e) => setF({ ...f, company: { ...f.company, regime_fiscale: e.target.value } })} className="w-full h-10 px-3 border border-[#E2DDD5] rounded-md bg-white text-sm" data-testid="rd-company-regime_fiscale">
                {REGIMI.map((r) => <option key={r} value={r}>{r}</option>)}
              </select>
            </div>
          </div>
          {!isEdit && (
            <label className="flex items-center gap-2 text-sm" data-testid="rd-send-invite">
              <Checkbox checked={f.send_invite} onCheckedChange={(v) => setF({ ...f, send_invite: !!v })} />
              Invia subito l'email di invito con il link di registrazione
            </label>
          )}
          {!isEdit && <p className="text-xs text-slate-500">Il rivenditore dovrà comunque caricare i documenti e l'accordo firmato, che Lei approverà.</p>}
        </div>
        <DialogFooter>
          <Button disabled={saving || !f.email} onClick={() => onSave(f)} className="bg-[#B84A2B] hover:bg-[#983C21] text-white" data-testid="rd-save">{isEdit ? "Salva modifiche" : "Crea rivenditore"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
